import React, { useContext } from 'react'
import classNames from 'classnames'
import DesktopMenu from './DesktopMenu'
import { I18nextContext } from '@toasttab/shared/src/context/i18nextContext'
import { usePageContext } from '@toasttab/shared/src/hooks/usePageContext'
import { useNavContext } from '@toasttab/shared/src/components/organisms/Navigation/Contentful/useNavContext'
import { localizeLink } from '@toasttab/shared/src/utils/linkUtils'
import { MenuProps } from '@toasttab/shared/src/components/organisms/Navigation/Contentful/ContentfulNavigation.d'

const DesktopNavItem = ({
  title,
  dropdownContent,
  handleCloseNav,
  heapClass,
  linkUrl
}: MenuProps) => {
  const localizationContext = useContext(I18nextContext)
  const { headerHeight, setHeaderHeight } = usePageContext()
  const {
    isKeyboardNavigation,
    selectedParentMenu,
    setIsKeyboardNavigation,
    setIsOverlayOpen,
    setSelectedParentMenu
  } = useNavContext()

  const parentMenuCss = classNames(
    // Have to use text-[15px] because OTL and main use different variables
    'group/parent-item font-effra text-[15px] text-default border-b-4 hover:border-blue-75 px-3 hidden lg:flex h-full items-center',
    {
      'border-transparent': title !== selectedParentMenu,
      'border-blue-75': title === selectedParentMenu
    }
  )

  const handleOpen = () => {
    setIsOverlayOpen(true)
    setSelectedParentMenu(title)
    // Re-set headerHeight when nav is opened, to ensure it's in the right position
    const headHeight =
      typeof document !== 'undefined'
        ? document.querySelector('.headerContent')?.clientHeight
        : 0
    if (headHeight > 0 && headHeight !== headerHeight) {
      setHeaderHeight(headHeight)
    }
  }
  const handleMouseEnter = () => {
    setIsKeyboardNavigation(false)
    handleOpen()
  }

  return dropdownContent?.subMenus ? (
    <li
      className={parentMenuCss}
      data-testid='DesktopNav-parentMenu'
      key={`desktop-parent-dropdown-${title}}`}
      onClick={handleOpen}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleCloseNav}
      role='none'
    >
      <button
        aria-controls={`${title.replace(/\s/g, '-')}-menu`}
        aria-expanded={title === selectedParentMenu}
        aria-haspopup='true'
        className={`${heapClass} leading-none bg-white mt-1 flex items-center`}
        role='menuitem'
      >
        {title}
        <span className='inline-block h-4 w-6 ml-1 -mt-px transition-all after:content-icon-caret-down-blue group-hover/parent-item:rotate-180 group-focus/parent-item:rotate-180' />
      </button>
      <DesktopMenu
        dropdownContent={dropdownContent}
        handleCloseNav={handleCloseNav}
        title={title}
      />
    </li>
  ) : (
    <li
      className={`${parentMenuCss} px-3`}
      data-testid='DesktopNav-parentMenu-link'
      key={`desktop-parent-link-${title}}`}
      onMouseEnter={() => setSelectedParentMenu(null)}
      role='none'
    >
      <a
        className={`${heapClass} leading-none text-default font-normal mt-[3px]`}
        role='menuitem'
        href={localizeLink(
          linkUrl,
          localizationContext.language,
          localizationContext
        )}
      >
        {title}
      </a>
    </li>
  )
}

export default DesktopNavItem
